import React from 'react';
import {View, Text, Image} from 'react-native';
import {copyRight, copyRightColor, FONT_FAMILY_MEDIUM} from './utils';
import logger from './logger';
export const CopyRight = props => {
   logger(props.isProfileScreen);
   const isLandScapeMode = props.screenOrientation;
   const isCopyrightShown = props.isCopyrightShown;

   return isCopyrightShown ? (
      <View
         style={{
            position:
               props.isProfileScreen === undefined ||
               props.isProfileScreen === false
                  ? 'absolute'
                  : 'relative',
            bottom: 0,
            left: 0,
            right: 0,
            alignItems: 'center',
            flexDirection: isLandScapeMode ? 'row' : 'column',
            justifyContent: isLandScapeMode ? 'space-between' : 'center',
            marginLeft: isLandScapeMode ? 16 : 0,
            marginRight: isLandScapeMode ? 16 : 0,
            marginBottom: isLandScapeMode ? 8 : 0,
         }}>
         <Image
            source={require('../assets/norcat-black-logo.png')}
            style={{
               resizeMode: 'center',
               maxHeight: 16,
               maxWidth: 122,
               height: 16,
               width: 122,
            }}
         />
         <Text
            style={{
               fontSize: 12,
               fontWeight: '500',
               color: copyRightColor,
               marginTop: 10,
               fontFamily: FONT_FAMILY_MEDIUM,
               marginBottom: 10,
            }}>
            {copyRight}
         </Text>
      </View>
   ) : (
      <></>
   );
};
